module.exports = __webpack_public_path__ + "static/img/5f.111bafd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5f.jpg
// module id = +bGN
// module chunks = 0